<template>
  <div class="header">
    <div class="header-title">
      汉川市综合产权交易平台
    </div>
    <div class="header-tab-bar">
      <div class="login">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <tab-bar>
        <tab-bar-item path="/homePage" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/home.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/home_active.svg"/> -->
          <div slot="item-text">首页</div>
        </tab-bar-item>
        <!-- <tab-bar-item path="/newsCenter" :activeColor="activeColor">
          <div slot="item-text">工作动态</div>
        </tab-bar-item> -->
        <tab-bar-item path="/projectCenter" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/shopcart.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/shopcart_active.svg" /> -->
          <div slot="item-text">项目中心</div>
        </tab-bar-item>
        <tab-bar-item path="/biddingHall" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/profile.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/profile_active.svg" /> -->
          <div slot="item-text">竞价大厅</div>
        </tab-bar-item>
		<!-- <a href="http://localhost/login?redirect=%2Findex"> -->
        <tab-bar-item path="/projectAnn" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/category.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/category_active.svg" /> -->
          <div slot="item-text">项目公告</div>
        </tab-bar-item>
		<!-- </a> -->
        <tab-bar-item path="/regulation" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/shopcart.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/shopcart_active.svg" /> -->
          <div slot="item-text">政策法规</div>
        </tab-bar-item>
        <tab-bar-item path="/contactUs" :activeColor="activeColor">
          <!-- <img slot="item-icon" src="~assets/img/tabbar/profile.svg" />
          <img slot="item-icon-active" src="~assets/img/tabbar/profile_active.svg" /> -->
          <div slot="item-text">通知公告</div>
        </tab-bar-item>
      </tab-bar>
    </div>
    
  </div>
</template>

<script>
// 组件
import TabBar from "@/components/common/tabbar/TabBar";
import TabBarItem from "@/components/common/tabbar/TabBarItem";

import * as constant from "@/common/const";

export default {
  name: "CqjyHeader",
  data() {
    return {
      activeColor: constant.ACTIVE_COLOR,
    };
  },
  components: {
    TabBar,
    TabBarItem,
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.header {
  display: flex;
  // padding: 20px 0;
  padding: 36px 0 20px;
  .header-title {
    width: 34%;
    display: flex;
    align-items: center;
    padding-left: 175px;
    font-size: 28px;
    font-weight: 600;
  }
  .header-tab-bar {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .login {
      display: flex;
      justify-content: flex-end;
      height: 30px;
    }
  }
}
</style>